<template>
  <div>
    <ValidationObserver ref="form">
      <div class="grid">
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3 class="mb-4">
              <strong>{{ $t("InfoGeneral") }}</strong>
            </h3>
          </div>

          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <label>{{ $t("Imagen") }}</label>
              <ImageDropzone ref="images"></ImageDropzone>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-3/3 w-full mt-2">
            <p style="color: rgba(var(--vs-warning), 1) !important">
              <font-awesome-icon class="mr-2 ml-2" :icon="['fa', 'exclamation-triangle']" />
              {{ $t('warningImagesPopup') }}
            </p>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider
                name="Url"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  label-placeholder="Url"
                  v-model="url"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-4 mb-3">
            <vs-checkbox @change="changeIsPermanent()" v-model="isPermanent">{{
              $t("popUps.Permanent")
            }}</vs-checkbox>
          </div>

          <div
            class="vx-col md:w-9/12 w-full mb-5"
            style="width: min-content"
            v-if="!isPermanent"
          >
            <ValidationProvider
              name="Periodo"
              rules="required"
              v-slot="{ errors }"
            >
              <CalendarRangeInput
                v-model="dateRange"
                class="w-full"
                :dateFromCurrent="false"
              ></CalendarRangeInput>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full mt-1" style="width: min-content">
            <label>{{ $t("Activo") }}</label>
            <vs-switch v-model="active" icon-pack="feather" />
          </div>

          <div class="vx-col w-full text-right">
            <vs-button
              depressed
              color="success"
              type="border"
              class="mr-2"
              @click.prevent="handleSubmit"
            >
              {{ $t("popUps.CreatePopUp") }}
            </vs-button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import ImageDropzone from '../ImageDropzone.vue';
import TimeRangeInput from '../time-range-input/TimeRangeInput.vue';
import CalendarRangeInput from '../calendar-range-input/CalendarRangeInput.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    ImageDropzone,
    draggable,
    TimeRangeInput,
    CalendarRangeInput,
  },
  props: {
    idRestaurant: {
      type: Number,
      required: false,
    },
  },
  expose: ['resetForm'],

  data() {
    return {
      myFile: '',
      started_at: '',
      finished_at: '',
      image: '',
      url: '',
      active: false,
      isPermanent: false,
    };
  },
  watch: {
    createdCorrect() {
      if (this.createdCorrect === true) {
        Object.assign(this.$data, this.returnInitialData());
        this.$refs.images.emptyDropzone();
        this.setCreatedCorrect(false);
      }
    },
  },

  computed: {
    ...mapGetters({
      currentRestaurant: 'getCurrentRestaurant',
      language: 'getCurrentLanguage',
      createdCorrect: 'getCreatedCorrectPopUp',
    }),
    dateRange: {
      set(val) {
        this.started_at = val.fromDate;
        this.finished_at = val.toDate;
      },
      get() {
        return {
          fromDate: this.started_at,
          toDate: this.finished_at,
        };
      },
    },

    currentPage: {
      get() {
        return this.currentPageNumber;
      },
      set(currentPageNumber) {
        this.currentPageNumber = currentPageNumber;
        return this.currentPageNumber;
      },
    },
    data() {
      const results = [];

      return results;
    },
  },
  methods: {
    ...mapActions({
      createPopUp: 'createPopUp',
    }),
    ...mapMutations({
      setCreatedCorrect: 'setCreatedCorrect',
    }),

    resetForm() {
      Object.assign(this.$data, this.returnInitialData());
      this.$refs.images.emptyDropzone();
      this.$refs.form.reset();
    },

    returnInitialData() {
      return {
        myFile: '',
        started_at: '',
        finished_at: '',
        image: '',
        url: '',
        active: false,
        isPermanent: false,
      };
    },
    changeIsPermanent() {
      if (this.isPermanent) {
        this.started_at = '';
        this.finished_at = '';
      }
    },
    setRangeHours(event) {
      this.started_at = event.fromTime;
      this.finished_at = event.toTime;
    },
    normalizeTotalPages(totalPages) {
      this.maxPages = Math.ceil(totalPages);
      this.dataColumnsPaged = this.data.slice(
        this.currentPage * this.itemsPerPage - this.itemsPerPage,
        this.currentPage * this.itemsPerPage
      );
    },
    isFile(input) {
      if ('File' in window && input instanceof File) return true;
      else return false;
    },
    checkImages(){
        global.jQuery = require('jquery');
        var $ = global.jQuery;
        const vsSelectedCategories=document.getElementsByClassName('dz-preview')[0];
        if(vsSelectedCategories!==undefined&&vsSelectedCategories)return true;
        else return false;
      },
    handleSubmit() {
      this.$refs.form.validate().then((success) => {
        const formData = this.createFormData();
        if (!this.checkImages()) {
          success = false;
        }
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            if(errors&&errors!==undefined){
              Object.keys(errors).forEach((key) => {
                const error = errors[key];
                if (error.length) {
                  error.forEach(function (text) {
                    textAux += `<p>${text}</p>`;
                  });
                }
              });
            }
            if (!this.checkImages()) {
              textAux += "<p>El campo Imágenes es obligatorio</p>";
            }
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          return;
        }

        this.submitted = true;

        this.createPopUp({
          popUp: formData,
          language: this.language,
          restaurant_id: this.idRestaurant,
        });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },

    createFormData() {
      const data = this.$refs.images.getFormData();
      const activeValue = this.active ? 1 : 0;
      const url = this.url.includes('http') ? this.url : `https://${this.url}`;

      data.append('url', url);
      data.append('started_at', this.started_at);
      data.append('finished_at', this.finished_at);
      data.append('active', activeValue);
      data.append(
        'restaurant_id',
        this.idRestaurant ? this.idRestaurant : null
      );
      return data;
    },
  },
};
</script>
<style></style>
